/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_AlignInputs */

const cs_enum_align = /** @type {(inputs: Enum_AlignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarovnání`)
};

const en_enum_align = /** @type {(inputs: Enum_AlignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Align`)
};

/**
* | output |
* | --- |
* | "Align" |
*
* @param {Enum_AlignInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_align = /** @type {((inputs?: Enum_AlignInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_AlignInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_align(inputs)
	return cs_enum_align(inputs)
});